export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneRegex = /^(?:(?:\d{8}|\d{10})|\d{2}-\d{2}-\d{2}-\d{2}-\d{2}|\d{2}-\d{2}-\d{2}-\d{2})$/;
export const amountRegex = /^(0|[1-9]\d*)(\.\d+)?$/;

// export const integerRegex = /^^(0|[1-9]\d{0,7}|100000000)$/; // valida números entre 0 y 100,000,000
// export const integerRegex = /^(0|[1-9]\d{0,8})$/; //Valida numeros de 0 a 999,999,999
export const integerRegex = /^\d+$/; // Acepta uno o más dígitos
export const priceRegex = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/; //Valida cantidades en formato $ => 1,000, 10,000 o 1
